<template>
    <div>
        <tab name="3"></tab>
        <el-alert type="warning" title="注意" :closable="false">
            <div>常用于姓名包含生僻字等特殊情况，导致无法正常通过认证的证件信息</div>
        </el-alert>
        <div class="page-btns-box MT20">
            <el-button v-if="$utils.have('/commonPerformer/exemptAdd')" type="primary" @click="$refs.exemptAdd.show()"
                size="small">添加免检证件</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column label="证件类型" prop="documentType"></el-table-column>
                <el-table-column label="证件姓名" prop="documentName"></el-table-column>
                <el-table-column label="证件号码" prop="documentNumber"></el-table-column>
                <el-table-column label="照片留底" >
                    <template slot-scope="{row} = scope">
                        <el-button v-if="row.photoUrl" type="text" size="mini" @click="previewImg(row.photoUrl)">点击查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="添加时间" prop="createTime" min-width="150"></el-table-column>
                <el-table-column label="添加人" prop="createUser"></el-table-column>
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <exempt-add ref="exemptAdd" @update="search"></exempt-add>
        <el-image-viewer v-if="showViewer && imageViewerUrl" :on-close="() => { showViewer = false }"
            :url-list="[imageViewerUrl]" :z-index="100000" />
    </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import Tab from './components/tab';
import exemptAdd from './components/exemptAdd.vue';
const defaultParams = {
    pageNo: 1,
}
export default {
    components: { Tab, ElImageViewer,exemptAdd },
    data() {
        return {
            listLoading: false,
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            showViewer: false,
            imageViewerUrl: ""
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
            }
            this.$request({
                url: "/commonPerformer/exemptList",
                method: "POST",
                params: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result?.result;
                    } else {
                        this.data = null;
                        this.dataList = null;
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.data = null;
                    this.dataList = null;
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = { ...defaultParams }
            this.getDataList();
        },
        //预览
        previewImg(src) {
            this.showViewer = true;
            this.imageViewerUrl = src;
        },
    }
}
</script>

<style lang="scss" scoped></style>